// Client portal translations
// Includes: dashboard, questionnaire, orders, points, offers, settings, shopcart, shoppingCart, accommodations (client-facing), activities (client-facing), packages, chalets, guest, home

export const clientTranslations = {
  fr: {
    // Dashboard
    'dashboard.welcome': 'Bienvenue, {name} !',
    'dashboard.subtitle': 'Découvrez nos chalets rustiques et activités nature au cœur de l\'Abitibi-Témiscamingue',
    'dashboard.availableChalets': 'Chalets disponibles',
    'dashboard.activities': 'Activités',
    'dashboard.specialPackages': 'Forfaits spéciaux',
    'dashboard.pureNature': 'Nature pure',
    'dashboard.featuredChalets': 'Chalets en vedette',
    'dashboard.popularActivities': 'Activités populaires',
    'dashboard.specialOffers': 'Offres spéciales',
    'dashboard.viewAll': 'Voir tout',
    'dashboard.bookNow': 'Réserver maintenant',
    'dashboard.lastVisit': 'Dernière visite',
    'dashboard.recentActivity': 'Activité récente',
    'dashboard.satisfaction': 'Satisfaction',
    'dashboard.averageRating': 'Note moyenne',
    'dashboard.basedOnRatings': 'Basé sur vos évaluations',
    'dashboard.yourComment': 'Votre commentaire',
    'dashboard.lastReview': 'Dernier avis',
    'dashboard.viewAllComments': 'Voir tous les commentaires',
    'dashboard.activeReservations': 'Réservations actives',
    'dashboard.pendingPayments': 'Paiements en attente',
    'dashboard.completedStays': 'Séjours terminés',
    'dashboard.totalSpent': 'Total dépensé',
    'dashboard.upcomingReservations': 'Réservations à venir',
    'dashboard.noUpcomingReservations': 'Aucune réservation à venir',
    'dashboard.noReservationsPlanned': 'Vous n\'avez actuellement aucune réservation planifiée',
    'dashboard.newReservation': 'Nouvelle réservation',
    'dashboard.orderManagement': 'Gestion de vos commandes',
    'dashboard.manageReservations': 'Gérez vos réservations, modifiez vos dates, annulez ou complétez vos paiements',
    'dashboard.viewAllOrders': 'Voir toutes mes commandes',
    'dashboard.today': 'Aujourd\'hui',
    'dashboard.yesterday': 'Hier',
    'dashboard.daysAgo': 'Il y a {count} jours',
    'dashboard.weeksAgo': 'Il y a {count} semaine{s}',
    'dashboard.monthsAgo': 'Il y a {count} mois',
    'dashboard.yearsAgo': 'Il y a {count} an{s}',
    'dashboard.pointsMilestone': 'Jalons et aperçu de mes points',
    'dashboard.pointsInsight': 'Aperçu des points',
    'dashboard.nextMilestone': 'Prochain jalon',
    'dashboard.pointsUntilNext': '{points} points jusqu\'au prochain jalon',
    'dashboard.reservationBoard': 'Tableau des réservations',
    'dashboard.reservationDetails': 'Détails de la réservation',
    'dashboard.satisfactionFeedback': 'Satisfaction et commentaires',
    'dashboard.leaveFeedback': 'Laisser un commentaire',
    'dashboard.feedbackTitle': 'Partagez votre expérience',
    'dashboard.feedbackDescription': 'Votre avis nous aide à améliorer nos services',
    'dashboard.rating': 'Note',
    'dashboard.comment': 'Commentaire',
    'dashboard.submitFeedback': 'Soumettre le commentaire',
    'dashboard.yourRating': 'Votre note',
    'dashboard.writeComment': 'Écrivez votre commentaire ici...',
    'dashboard.person': 'personne',
    'dashboard.persons': 'personnes',
    'dashboard.loyaltyPointWorth': '1 point = {value} $ CAD de réduction',
    'dashboard.loyaltyApproxCredit': '≈ {amount} $ CAD en réductions',
    'dashboard.loyaltyTotalSpentBeforeTax': 'Dépenses totales (avant taxes) : {amount} $',
    'dashboard.vumNoPackages': 'Aucun forfait VUM prêt à utiliser',
    'dashboard.vumPackagesReady': '{count} forfait(s) VUM prêt(s) à réserver',
    'dashboard.milestoneReachLevel': 'Pour atteindre le niveau {label}',

    // Questionnaire
    'questionnaire.title': 'Questionnaire',
    'questionnaire.start': 'Répondre au questionnaire',
    'questionnaire.answerToAccumulate': 'Répondre aux questions pour accumuler des points',
    'questionnaire.question': 'Question',
    'questionnaire.submit': 'Soumettre',
    'questionnaire.next': 'Suivant',
    'questionnaire.previous': 'Précédent',
    'questionnaire.progress': 'Question {current} sur {total}',
    'questionnaire.pointsReward': '+{points} points',
    'questionnaire.ratingSelected': 'Vous avez sélectionné {rating} étoiles',
    'questionnaire.textHint': 'Votre réponse nous aide à améliorer nos services',
    'questionnaire.completed': 'Questionnaire complété ! Vous avez gagné {points} points.',
    'questionnaire.textPlaceholder': 'Tapez votre réponse ici...',
    'questionnaire.q1.question': 'Quelle est votre activité préférée en camping ?',
    'questionnaire.q1.option1': 'Randonnée',
    'questionnaire.q1.option2': 'Pêche',
    'questionnaire.q1.option3': 'Observation de la faune',
    'questionnaire.q1.option4': 'Détente au chalet',
    'questionnaire.q2.question': 'Comment évaluez-vous votre expérience globale ?',
    'questionnaire.q3.question': 'Avez-vous des suggestions pour améliorer nos services ?',

    // Orders Management
    'orders.title': 'Mes commandes',
    'orders.navLabel': 'Mes commandes',
    'orders.subtitle': 'Gérez vos réservations et consultez l\'historique de vos séjours',
    'orders.upcoming': 'À venir',
    'orders.past': 'Passées',
    'orders.cancelled': 'Annulées',
    'orders.noUpcoming': 'Aucune réservation à venir',
    'orders.noPast': 'Aucune réservation passée',
    'orders.noCancelled': 'Aucune réservation annulée',
    'orders.startBooking': 'Commencez par réserver un hébergement',
    'orders.pastWillAppear': 'Vos réservations passées apparaîtront ici',
    'orders.cancelledWillAppear': 'Vos réservations annulées apparaîtront ici',
    'orders.confirmed': 'Confirmée',
    'orders.pending': 'En attente',
    'orders.cancelledStatus': 'Annulée',
    'orders.paid': 'Payée',
    'orders.paymentPartial': 'Partiellement payé',
    'orders.paymentPending': 'Non payé',
    'orders.refunded': 'Remboursée',
    'orders.modify': 'Modifier',
    'orders.cancel': 'Annuler',
    'orders.pay': 'Payer',
    'orders.payToComplete': 'Payer pour compléter',
    'orders.viewDetails': 'Voir détails',
    'orders.reservedOn': 'Réservée le {date}',
    'orders.paymentComplete': 'Paiement complet',
    'orders.paymentPendingStatus': 'Paiement en attente',
    'orders.balanceDueAtArrival': 'Solde dû à l\'arrivée : {amount} $ CAD',
    'orders.amountDue': 'Montant dû : {amount} $ CAD',
    'orders.priceTotal': 'Total',
    'orders.pricePaid': 'Payé',
    'orders.priceBalance': 'Solde à l\'arrivée',
    'orders.cancelModal.title': 'Annuler la réservation',
    'orders.cancelModal.message': 'Êtes-vous sûr de vouloir annuler cette réservation ? Cette action est irréversible. Un remboursement sera effectué selon notre politique d\'annulation.',
    'orders.cancelModal.back': 'Retour',
    'orders.cancelModal.confirm': 'Confirmer l\'annulation',
    'orders.modifyModal.title': 'Modifier la réservation',
    'orders.modifyModal.checkIn': 'Date d\'arrivée',
    'orders.modifyModal.checkOut': 'Date de départ',
    'orders.modifyModal.guests': 'Nombre de personnes',
    'orders.modifyModal.save': 'Enregistrer les modifications',
    'orders.paymentModal.title': 'Compléter le paiement',
    'orders.paymentModal.totalAmount': 'Montant total',
    'orders.paymentModal.cardNumber': 'Numéro de carte',
    'orders.paymentModal.cardNumberPlaceholder': '1234 5678 9012 3456',
    'orders.paymentModal.expiryDate': 'Date d\'expiration',
    'orders.paymentModal.expiryPlaceholder': 'MM/AA',
    'orders.paymentModal.cvv': 'CVV',
    'orders.paymentModal.cvvPlaceholder': '123',
    'orders.paymentModal.pay': 'Payer {amount}$ CAD',
    'orders.needHelpTitle': 'Besoin d\'aide avec vos réservations ?',
    'orders.needHelpSubtitle': 'Notre équipe est là pour vous aider avec vos questions et modifications',
    'orders.newReservation': 'Nouvelle réservation',
    'orders.contactSupport': 'Contacter le support',
    'orders.contactToModify': 'Pour modifier ou annuler, veuillez contacter le camping.',
    'orders.lodgeName': 'Pourvoirie Pignon Rouge',
    'orders.completed': 'Terminée',
    'orders.cancelModalTitle': 'Annuler la réservation',
    'orders.cancelModalSubtitle': 'Êtes-vous sûr de vouloir annuler cette réservation ? Cette action est irréversible.',
    'orders.confirmCancellation': 'Confirmer l\'annulation',
    'orders.modifyModalTitle': 'Modifier la réservation',
    'orders.saveModifications': 'Enregistrer les modifications',
    'orders.paymentModalTitle': 'Compléter le paiement',
    'orders.paymentModalSubtitle': 'Veuillez entrer vos informations de paiement pour compléter la réservation.',
    'orders.completePayment': 'Compléter le paiement',
    'orders.help.title': 'Besoin d\'aide avec vos réservations ?',
    'orders.help.description': 'Notre équipe est là pour vous aider avec vos questions et modifications',
    'orders.help.newReservation': 'Nouvelle réservation',
    'orders.help.contactSupport': 'Contacter le support',
    'orders.billings': 'Factures',
    'orders.billings.title': 'Mes factures',
    'orders.billings.subtitle': 'Consultez et téléchargez vos factures',
    'orders.billings.invoice': 'Facture',
    'orders.billings.date': 'Date',
    'orders.billings.amount': 'Montant',
    'orders.billings.status': 'Statut',
    'orders.billings.download': 'Télécharger',
    'orders.billings.view': 'Voir',
    'orders.billings.paid': 'Payée',
    'orders.billings.pending': 'En attente',
    'orders.billings.overdue': 'En retard',
    'orders.billings.noBillings': 'Aucune facture disponible',
    'orders.billings.noBillingsDesc': 'Vos factures apparaîtront ici après vos réservations',
    'orders.waitingToComplete': 'En attente de paiement',
    'orders.noPaid': 'Aucune réservation payée',
    'orders.noPaidDesc': 'Vos réservations payées apparaîtront ici',
    'orders.noWaiting': 'Aucune réservation en attente',
    'orders.noWaitingDesc': 'Vos réservations en attente de paiement apparaîtront ici',
    'orders.reminder.title': 'Rappels importants',
    'orders.reminder.cancellationDeadline': '⚠️ Délai d\'annulation: Moins de 5 jours avant l\'arrivée',
    'orders.reminder.modificationDeadline': '⚠️ Délai de modification: Moins de 7 jours avant l\'arrivée',

    // Points Management
    'points.title': 'Mes Points',
    'points.navLabel': 'Mes Points',
    'points.subtitle': 'Gérez vos points de fidélité et échangez-les contre des récompenses',
    'points.current': 'Points actuels',
    'points.lifetime': 'Points à vie',
    'points.availableRewards': 'Récompenses disponibles',
    'points.pointValue': '1 point = 0.10$ CAD',
    'points.reduction': 'réduction',
    'points.estimatedCreditLine': 'Crédit estimé : {amount} $ CAD',
    'points.adjustment': 'Ajustement des points',
    'points.adjustmentDesc': 'Les administrateurs peuvent ajuster les points de fidélité des membres',
    'points.adjust': 'Ajuster les points',
    'points.rewards': 'Récompenses disponibles',
    'points.transactionHistory': 'Historique des transactions',
    'points.earned': 'Points gagnés pour réservation',
    'points.redeemed': 'Échange pour réduction de {amount}$',
    'points.adjusted': 'Ajustement administratif',
    'points.adjustModal.title': 'Ajuster les points',
    'points.adjustModal.amount': 'Montant (positif pour ajouter, négatif pour retirer)',
    'points.adjustModal.amountPlaceholder': 'Ex: 100 ou -50',
    'points.adjustModal.reason': 'Raison de l\'ajustement',
    'points.adjustModal.reasonPlaceholder': 'Expliquez la raison de cet ajustement...',
    'points.adjustModal.confirm': 'Confirmer l\'ajustement',
    'points.reward.discount25': 'Réduction de 25$',
    'points.reward.discount25Desc': 'Économisez 25$ sur votre prochaine réservation',
    'points.reward.discount50': 'Réduction de 50$',
    'points.reward.discount50Desc': 'Économisez 50$ sur votre prochaine réservation',
    'points.reward.freeNight': 'Nuit gratuite',
    'points.reward.freeNightDesc': 'Obtenez une nuit gratuite pour votre séjour',
    'points.reward.vipPackage': 'Forfait VIP',
    'points.reward.vipPackageDesc': 'Accès au forfait VIP avec tous les avantages',
    'points.reward.exchange': 'Échanger',
    'points.reward.pointsRequired': '{points} points',
    'points.transaction.earnedReservation': 'Points gagnés pour réservation',
    'points.transaction.redeemedDiscount': 'Échange pour réduction de {amount}$',
    'points.transaction.adminAdjustment': 'Ajustement administratif',
    'points.points': 'points',
    'points.currentLabel': 'Points actuels',
    'points.lifetimeLabel': 'Points à vie',
    'points.availableRewardsLabel': 'Récompenses disponibles',

    // Offers Management
    'offers.title': 'Mes Offres',
    'offers.navLabel': 'Mes Offres',
    'offers.subtitle': 'Consultez et utilisez les offres spéciales qui vous ont été envoyées',
    'offers.active': 'Offres actives',
    'offers.expired': 'Offres expirées',
    'offers.used': 'Offres utilisées',
    'offers.noActive': 'Aucune offre active',
    'offers.noExpired': 'Aucune offre expirée',
    'offers.noUsed': 'Aucune offre utilisée',
    'offers.noActiveDesc': 'Vous n\'avez actuellement aucune offre active',
    'offers.noExpiredDesc': 'Aucune offre expirée dans votre historique',
    'offers.noUsedDesc': 'Aucune offre utilisée dans votre historique',
    'offers.activeStatus': 'Active',
    'offers.expiredStatus': 'Expirée',
    'offers.usedStatus': 'Utilisée',
    'offers.promotionalCode': 'Code promotionnel',
    'offers.validFrom': 'Du {from} au {until}',
    'offers.terms': 'Conditions',
    'offers.useOffer': 'Utiliser l\'offre',
    'offers.discount': 'de réduction',
    'offers.multiplier': 'multiplicateur',
    'offers.activeLabel': 'Offres actives',
    'offers.expiredLabel': 'Offres expirées',
    'offers.usedLabel': 'Offres utilisées',
    'offers.tabActive': 'Actives',
    'offers.tabExpired': 'Expirées',
    'offers.tabUsed': 'Utilisées',
    'offers.example1.title': 'Réduction de 20% sur votre prochaine réservation',
    'offers.example1.description': 'Profitez d\'une réduction de 20% sur tous les hébergements disponibles. Valable jusqu\'à la fin du mois.',
    'offers.example1.terms': 'Minimum 2 nuits. Non cumulable avec d\'autres offres.',
    'offers.example2.title': '50$ de réduction',
    'offers.example2.description': 'Économisez 50$ sur votre réservation de 3 nuits ou plus.',
    'offers.example2.terms': 'Réservation de 3 nuits minimum requise.',
    'offers.example3.title': 'Doublez vos points de fidélité',
    'offers.example3.description': 'Gagnez le double de points sur votre prochain séjour.',
    'offers.example3.terms': 'Offre valable en janvier 2024 uniquement.',
    'offers.example4.title': 'Weekend spécial - 15% de réduction',
    'offers.example4.description': 'Réduction spéciale pour les réservations de weekend.',
    'offers.example4.terms': 'Valable uniquement pour les réservations du vendredi au dimanche.',
    'offers.validFromTo': 'Du {from} au {until}',

    // Settings
    'settings.title': 'Paramètres du compte',
    'settings.navLabel': 'Paramètres',
    'settings.subtitle': 'Gérez vos informations personnelles et préférences de compte',
    'settings.personalInfo': 'Informations personnelles',
    'settings.updateProfile': 'Mettez à jour vos informations de profil',
    'settings.edit': 'Modifier',
    'settings.firstName': 'Prénom',
    'settings.lastName': 'Nom',
    'settings.email': 'Adresse courriel',
    'settings.phone': 'Téléphone',
    'settings.saveChanges': 'Enregistrer les modifications',
    'settings.preferences': 'Préférences',
    'settings.customizeExperience': 'Personnalisez votre expérience',
    'settings.preferredLanguage': 'Langue préférée',
    'settings.emailNotifications': 'Notifications par courriel',
    'settings.emailNotificationsDesc': 'Recevez des notifications sur vos réservations et offres spéciales',
    'settings.savePreferences': 'Enregistrer les préférences',
    'settings.security': 'Sécurité',
    'settings.managePassword': 'Gérez votre mot de passe et la sécurité de votre compte',
    'settings.changePassword': 'Changer le mot de passe',
    'settings.lastPasswordChange': 'Dernière modification du mot de passe: Il y a {months} mois',

    // Shopcart
    'shopcart.title': 'Mon panier',
    'shopcart.navLabel': 'Mon panier',
    'shopcart.subtitle': 'Gérez vos favoris, vos coups de cœur et partagez vos découvertes',
    'shopcart.favorites': 'Favoris',
    'shopcart.liked': 'J\'aime',
    'shopcart.shared': 'Partagés',
    'shopcart.addToFavorites': 'Ajouter aux favoris',
    'shopcart.removeFromFavorites': 'Retirer des favoris',
    'shopcart.like': 'J\'aime',
    'shopcart.unlike': 'Ne plus aimer',
    'shopcart.share': 'Partager',
    'shopcart.noFavorites': 'Aucun favori',
    'shopcart.noFavoritesDesc': 'Ajoutez des hébergements ou activités à vos favoris',
    'shopcart.noLiked': 'Aucun élément aimé',
    'shopcart.noLikedDesc': 'Les éléments que vous aimez apparaîtront ici',
    'shopcart.noShared': 'Aucun élément partagé',
    'shopcart.noSharedDesc': 'Les éléments que vous partagez apparaîtront ici',
    'shopcart.shareSuccess': 'Lien copié dans le presse-papiers',
    'shopcart.remove': 'Retirer',
    'shopcart.viewDetails': 'Voir les détails',

    // Shopping Cart Assistant
    'shoppingCart.title': 'Assistant de réservation',
    'shoppingCart.subtitle': 'Planifiez votre séjour en quelques étapes',
    'shoppingCart.travelDuration': 'Durée du voyage',
    'shoppingCart.selectDates': 'Sélectionnez vos dates de début et de fin (2026-2027)',
    'shoppingCart.chooseFirstDay': 'Premier jour',
    'shoppingCart.chooseLastDay': 'Dernier jour',
    'shoppingCart.durationHint':
      'Ajustez les nuits, ou touchez deux jours sur le calendrier pour une période.',
    'shoppingCart.startDate': 'Date de début',
    'shoppingCart.endDate': 'Date de fin',
    'shoppingCart.notSelected': 'Non sélectionné',
    'shoppingCart.applyingConditions': 'Application des conditions du panier',
    'shoppingCart.duration': 'Durée',
    'shoppingCart.days': 'jours',
    'shoppingCart.groupDetails': 'Détails du groupe',
    'shoppingCart.numberOfGroups': 'Nombre de groupes',
    'shoppingCart.group': 'groupe',
    'shoppingCart.groups': 'groupes',
    'shoppingCart.numberOfAdults': 'Nombre d\'adultes',
    'shoppingCart.adult': 'adulte',
    'shoppingCart.adults': 'adultes',
    'shoppingCart.numberOfKids': 'Nombre d\'enfants',
    'shoppingCart.kid': 'enfant',
    'shoppingCart.kids': 'enfants',
    'shoppingCart.totalGuests': 'Total invités',
    'shoppingCart.guests': 'invités',
    'shoppingCart.totalGroups': 'Total groupes',
    'shoppingCart.continue': 'Continuer',
    'shoppingCart.continueDescription': 'Vous pourrez ajouter des produits à votre panier',
    'shoppingCart.saveBookingConditions': 'Confirmer',
    'shoppingCart.bookingConditionsUpdated': 'Vos infos de voyage ont été mises à jour.',
    'shoppingCart.bookingConditions': 'Infos de voyage',
    'shoppingCart.updateTravelInfo': 'Mettre à jour les infos de voyage',
    'shoppingCart.updateTravelInfoDesc':
      'Enregistrez vos dates et la composition du groupe pour afficher les disponibilités correctes.',
    'shoppingCart.updateTravelInfoConfirm': 'Confirmer',
    'shoppingCart.discardTravelInfo': 'Ignorer les modifications',
    'shoppingCart.travelInfoRequired': 'Infos de voyage requises',
    'shoppingCart.travelInfoRequiredDesc':
      'Choisissez vos dates et votre groupe dans l’assistant calendrier pour voir les bons inventaires.',
    'shoppingCart.openTravelAssistant': 'Ouvrir l’assistant calendrier',
    'shoppingCart.startHereStep1': 'Commencez ici · Étape 1',
    'shoppingCart.startHereStep1Desc': 'Choisissez vos dates, puis le nombre de groupes.',
    'shoppingCart.milestoneDuration': 'Durée',
    'shoppingCart.milestoneGroups': 'Groupes',
    'shoppingCart.calendarDockImHere': 'Je suis ici',
    'shoppingCart.calendarDockImHereDesc': 'Rouvrez l’assistant calendrier depuis le dock.',
    'shoppingCart.myCart': 'Mon panier',
    'shoppingCart.stepItems': 'Articles',
    'shoppingCart.stepSummary': 'Total',
    'shoppingCart.stepCheckout': 'Paiement',
    'shoppingCart.stepSummaryHint': 'Vérifiez les taxes et le total pour les articles sélectionnés.',
    'shoppingCart.stepCheckoutHint': 'Choisissez comment finaliser votre commande.',
    'shoppingCart.capacityBlockedHint':
      'La taille du groupe dépasse les limites VUM — ajustez les voyageurs ou contactez-nous.',

    'shoppingCart.allItems': 'Tous les articles',
    'shoppingCart.liked': 'J\'aime',
    'shoppingCart.favorites': 'Favoris',
    'shoppingCart.cartEmpty': 'Votre panier est vide',
    'shoppingCart.cartEmptyDesc': 'Ajoutez des hébergements, activités ou forfaits à votre panier',
    'shoppingCart.noLikedItems': 'Aucun article aimé',
    'shoppingCart.noLikedItemsDesc': 'Les articles que vous aimez apparaîtront ici',
    'shoppingCart.noFavorites': 'Aucun favori',
    'shoppingCart.noFavoritesDesc': 'Vos articles favoris apparaîtront ici',
    'shoppingCart.open': 'Ouvrir l\'assistant',
    'shoppingCart.configureWithAssistant': 'Configurer dans l\'assistant (dates et groupes)',
    'shoppingCart.minimize': 'Réduire',
    'shoppingCart.expand': 'Agrandir',
    'shoppingCart.or': 'ou',
    'shoppingCart.addGroup': 'Ajouter un groupe',

    'checkout.staySummaryTitle': 'Résumé du séjour',
    'checkout.staySummarySubtitle': 'Conditions enregistrées dans l’assistant',
    'checkout.nightsCount': '{n} nuits',
    'checkout.groupNumber': 'Groupe {n}',

    // Client-facing Accommodations
    'accommodations.subtitle': 'Découvrez nos chalets rustiques et yourtes au cœur de la nature québécoise',
    'accommodations.searchPlaceholder': 'Rechercher un hébergement...',
    'accommodations.typeFilter': 'Type d\'hébergement',
    'accommodations.locationFilter': 'Emplacement',
    'accommodations.capacityFilter': 'Capacité',
    'accommodations.viewCalendar': 'Voir calendrier',
    'accommodations.hideCalendar': 'Masquer le calendrier',
    'accommodations.typesCalendar': 'Calendrier des types d\'hébergements',
    'stays.viewCalendar': 'Voir calendrier',
    'stays.hideCalendar': 'Masquer le calendrier',
    'stays.typesCalendar': 'Calendrier des types d\'hébergements',
    'accommodations.typesDescription': 'Consultez la disponibilité par type d\'hébergement',
    'accommodations.availability': 'Disponibilité',
    'accommodations.close': 'Fermer',
    'accommodations.noResults': 'Aucun hébergement trouvé',
    'accommodations.tryOtherFilters': 'Essayez de modifier vos critères de recherche',
    'accommodations.resultsCount': 'hébergement trouvé',
    'accommodations.resultsCountPlural': 'hébergements trouvés',
    'accommodations.filtersApplied': 'Filtres appliqués',
    'accommodations.allTypes': 'Tous les types',
    'accommodations.allLocations': 'Toutes les locations',
    'accommodations.allCapacities': 'Toutes les capacités',
    'accommodations.chalets': 'Chalets',
    'accommodations.yourtes': 'Yourtes',
    'accommodations.units': 'Unités en rangée',
    'accommodations.lake': 'Bord du lac',
    'accommodations.forest': 'En forêt',
    'accommodations.mixed': 'Mixte',
    'accommodations.capacity2': '2 personnes',
    'accommodations.capacity4': '4 personnes',
    'accommodations.capacity6': '5-6 personnes',
    'accommodations.capacity7': '7+ personnes',
    'accommodations.chalets.desc': 'Chalets rustiques avec équipements complets',
    'accommodations.yourtes.desc': 'Yourtes confortables en pleine nature',
    'accommodations.units.desc': 'Unités modernes avec services',
    'accommodations.cabane': 'Cabane',
    'accommodations.cabane.desc': 'Cabanes traditionnelles de chasse/pêche',
    'accommodations.tente': 'Tente',
    'accommodations.tente.desc': 'Tentes de luxe avec équipements',

    // Client-facing Activities
    'activities.subtitle': 'Découvrez nos activités de pêche, chasse et nature, été comme hiver',
    'activities.seasonFilter': 'Filtrer par saison',
    'activities.viewCalendar': 'Voir calendrier',
    'activities.hideCalendar': 'Masquer le calendrier',
    'activities.typesCalendar': 'Calendrier des types d\'activités',
    'activities.typesDescription': 'Consultez la disponibilité par type d\'activité',
    'activities.availability': 'Disponibilité',
    'activities.close': 'Fermer',
    'activities.noResults': 'Aucune activité trouvée',
    'activities.tryOtherSeason': 'Essayez de sélectionner une autre saison',
    'activities.fishing': 'Pêche',
    'activities.fishing.desc': 'Pêche sur glace, pêche en rivière, pêche en lac',
    'activities.hunting': 'Chasse',
    'activities.hunting.desc': 'Chasse au cerf, chasse à l\'orignal, chasse au petit gibier',
    'activities.hiking': 'Randonnée',
    'activities.hiking.desc': 'Randonnée en raquettes, randonnée pédestre, randonnée en vélo',
    'activities.observation': 'Observation',
    'activities.observation.desc': 'Observation de la faune, observation des oiseaux',
    'activities.photography': 'Photographie',
    'activities.photography.desc': 'Photographie nature, photographie animalière',
    'activities.fishingWalleye': 'Pêche au doré',
    'activities.fishingWalleye.desc': 'Pêche guidée au doré jaune sur nos lacs privés',
    'activities.kayak': 'Kayak',
    'activities.kayak.desc': 'Location de kayak pour explorer les lacs',
    'activities.guidedHiking': 'Randonnée guidée',
    'activities.guidedHiking.desc': 'Randonnée en forêt avec guide naturaliste',
    'activities.deerHunting': 'Chasse au chevreuil',
    'activities.deerHunting.desc': 'Chasse guidée au chevreuil en forêt',
    'activities.crossCountrySkiing': 'Ski de fond',
    'activities.crossCountrySkiing.desc': 'Pistes de ski de fond entretenues',
    'activities.iceFishing': 'Pêche sur glace',
    'activities.iceFishing.desc': 'Pêche sur glace avec guide expérimenté',

    // Packages
    'packages.familyFishing': 'Forfait Pêche Familiale',
    'packages.familyFishing.desc': '2 nuits + pêche guidée + kayak pour toute la famille',
    'packages.romanticWeekend': 'Weekend Romantique',
    'packages.romanticWeekend.desc': '2 nuits en chalet intime + randonnée + dîner aux chandelles',
    'packages.winterAdventure': 'Aventure Hivernale',
    'packages.winterAdventure.desc': '3 nuits + ski de fond + pêche sur glace + yourte',

    // Chalets
    'chalets.leRenard': 'Le Renard',
    'chalets.leRenard.desc': 'Chalet rustique au bord du lac avec quai privé et foyer extérieur.',
    'chalets.leLynx': 'Le Lynx',
    'chalets.leLynx.desc': 'Chalet spacieux parfait pour les familles avec vue panoramique sur le lac.',
    'chalets.laPerdrix': 'La Perdrix',
    'chalets.laPerdrix.desc': 'Chalet intime en forêt, idéal pour un séjour romantique.',
    'chalets.leLoup': 'Le Loup',
    'chalets.leLoup.desc': 'Grand chalet de luxe avec toutes les commodités pour les grands groupes.',
    'chalets.leHuard': 'Le Huard',
    'chalets.leHuard.desc': 'Chalet compact au bord de l\'eau avec accès direct au lac.',
    'chalets.laBecasse': 'La Bécasse',
    'chalets.laBecasse.desc': 'Chalet entre lac et forêt, parfait pour les amateurs de nature.',
    'chalets.lOriginal': 'L\'Original',
    'chalets.lOriginal.desc': 'Chalet premium avec vue exceptionnelle et toutes les commodités.',

    // Guest
    'guest.accommodations.subtitle': 'Découvrez nos chalets rustiques et yourtes au cœur de la nature québécoise',
    'guest.activities.subtitle': 'Découvrez nos activités de pêche, chasse et nature, été comme hiver',
    'guest.packages.subtitle': 'Découvrez nos forfaits tout inclus pour une expérience complète en nature',
    'guest.dashboard.welcome': 'Bienvenue en mode invité',
    'guest.dashboard.explore': 'Explorez nos offres sans créer de compte',
    'guest.dashboard.createAccount': 'Créer un compte pour réserver',
    'guest.dashboard.login': 'Se connecter à un compte existant',

    // Home
    'home.featuredChalets': 'Chalets en vedette',
    'home.viewAll': 'Voir tout',
    'home.popularActivities': 'Activités populaires',
    'home.specialPackages': 'Forfaits spéciaux',
    'home.needHelp': 'Besoin d\'aide pour planifier vos activités ?',
    'home.helpDescription': 'Notre équipe d\'experts peut vous aider à créer l\'expérience parfaite selon vos préférences',
    'home.contactUs': 'Contactez-nous',
    'home.discoverPackages': 'Découvrez nos forfaits tout inclus pour une expérience complète en nature',
  },
  en: {
    // Dashboard
    'dashboard.welcome': 'Welcome, {name}!',
    'dashboard.subtitle': 'Discover our rustic cabins and nature activities in the heart of Abitibi-Témiscamingue',
    'dashboard.availableChalets': 'Available cabins',
    'dashboard.activities': 'Activities',
    'dashboard.specialPackages': 'Special packages',
    'dashboard.pureNature': 'Pure nature',
    'dashboard.featuredChalets': 'Featured cabins',
    'dashboard.popularActivities': 'Popular activities',
    'dashboard.specialOffers': 'Special offers',
    'dashboard.viewAll': 'View all',
    'dashboard.bookNow': 'Book now',
    'dashboard.lastVisit': 'Last visit',
    'dashboard.recentActivity': 'Recent activity',
    'dashboard.satisfaction': 'Satisfaction',
    'dashboard.averageRating': 'Average rating',
    'dashboard.basedOnRatings': 'Based on your ratings',
    'dashboard.yourComment': 'Your comment',
    'dashboard.lastReview': 'Last review',
    'dashboard.viewAllComments': 'View all comments',
    'dashboard.activeReservations': 'Active reservations',
    'dashboard.pendingPayments': 'Pending payments',
    'dashboard.completedStays': 'Completed stays',
    'dashboard.totalSpent': 'Total spent',
    'dashboard.upcomingReservations': 'Upcoming reservations',
    'dashboard.noUpcomingReservations': 'No upcoming reservations',
    'dashboard.noReservationsPlanned': 'You currently have no planned reservations',
    'dashboard.newReservation': 'New reservation',
    'dashboard.orderManagement': 'Order management',
    'dashboard.manageReservations': 'Manage your reservations, modify your dates, cancel or complete your payments',
    'dashboard.viewAllOrders': 'View all my orders',
    'dashboard.today': 'Today',
    'dashboard.yesterday': 'Yesterday',
    'dashboard.daysAgo': '{count} days ago',
    'dashboard.weeksAgo': '{count} week{s} ago',
    'dashboard.monthsAgo': '{count} month{s} ago',
    'dashboard.yearsAgo': '{count} year{s} ago',
    'dashboard.pointsMilestone': 'Milestones and insights of my points',
    'dashboard.pointsInsight': 'Points insight',
    'dashboard.nextMilestone': 'Next milestone',
    'dashboard.pointsUntilNext': '{points} points until next milestone',
    'dashboard.reservationBoard': 'Reservation Board',
    'dashboard.reservationDetails': 'Reservation details',
    'dashboard.satisfactionFeedback': 'Satisfaction and feedback',
    'dashboard.leaveFeedback': 'Leave feedback',
    'dashboard.feedbackTitle': 'Share your experience',
    'dashboard.feedbackDescription': 'Your feedback helps us improve our services',
    'dashboard.rating': 'Rating',
    'dashboard.comment': 'Comment',
    'dashboard.submitFeedback': 'Submit feedback',
    'dashboard.yourRating': 'Your rating',
    'dashboard.writeComment': 'Write your comment here...',
    'dashboard.person': 'person',
    'dashboard.persons': 'persons',
    'dashboard.loyaltyPointWorth': '1 point = {value} $ CAD toward discounts',
    'dashboard.loyaltyApproxCredit': '≈ {amount} $ CAD redeemable credit',
    'dashboard.loyaltyTotalSpentBeforeTax': 'Total spent (before tax): {amount} $',
    'dashboard.vumNoPackages': 'No VUM packages ready to use',
    'dashboard.vumPackagesReady': '{count} VUM package(s) ready to book',
    'dashboard.milestoneReachLevel': 'To reach the {label} tier',

    // Questionnaire
    'questionnaire.title': 'Questionnaire',
    'questionnaire.start': 'Answer Questionnaire',
    'questionnaire.answerToAccumulate': 'Answer questions to accumulate points',
    'questionnaire.question': 'Question',
    'questionnaire.submit': 'Submit',
    'questionnaire.next': 'Next',
    'questionnaire.previous': 'Previous',
    'questionnaire.progress': 'Question {current} of {total}',
    'questionnaire.pointsReward': '+{points} points',
    'questionnaire.ratingSelected': 'You selected {rating} stars',
    'questionnaire.textHint': 'Your answer helps us improve our services',
    'questionnaire.completed': 'Questionnaire completed! You earned {points} points.',
    'questionnaire.textPlaceholder': 'Type your answer here...',
    'questionnaire.q1.question': 'What is your favorite camping activity?',
    'questionnaire.q1.option1': 'Hiking',
    'questionnaire.q1.option2': 'Fishing',
    'questionnaire.q1.option3': 'Wildlife watching',
    'questionnaire.q1.option4': 'Relaxing at the cabin',
    'questionnaire.q2.question': 'How would you rate your overall experience?',
    'questionnaire.q3.question': 'Do you have any suggestions to improve our services?',

    // Orders Management
    'orders.title': 'My Orders',
    'orders.navLabel': 'My Orders',
    'orders.subtitle': 'Manage your reservations and view your stay history',
    'orders.upcoming': 'Upcoming',
    'orders.past': 'Past',
    'orders.cancelled': 'Cancelled',
    'orders.noUpcoming': 'No upcoming reservations',
    'orders.noPast': 'No past reservations',
    'orders.noCancelled': 'No cancelled reservations',
    'orders.startBooking': 'Start by booking accommodation',
    'orders.pastWillAppear': 'Your past reservations will appear here',
    'orders.cancelledWillAppear': 'Your cancelled reservations will appear here',
    'orders.confirmed': 'Confirmed',
    'orders.pending': 'Pending',
    'orders.cancelledStatus': 'Cancelled',
    'orders.paid': 'Paid',
    'orders.paymentPartial': 'Partially paid',
    'orders.paymentPending': 'Unpaid',
    'orders.refunded': 'Refunded',
    'orders.modify': 'Modify',
    'orders.cancel': 'Cancel',
    'orders.pay': 'Pay',
    'orders.payToComplete': 'Pay to Complete',
    'orders.viewDetails': 'View details',
    'orders.reservedOn': 'Reserved on {date}',
    'orders.paymentComplete': 'Payment complete',
    'orders.paymentPendingStatus': 'Payment pending',
    'orders.balanceDueAtArrival': 'Balance due at arrival: {amount} CAD',
    'orders.amountDue': 'Amount due: {amount} CAD',
    'orders.priceTotal': 'Total',
    'orders.pricePaid': 'Paid',
    'orders.priceBalance': 'Balance at arrival',
    'orders.cancelModal.title': 'Cancel reservation',
    'orders.cancelModal.message': 'Are you sure you want to cancel this reservation? This action is irreversible. A refund will be issued according to our cancellation policy.',
    'orders.cancelModal.back': 'Back',
    'orders.cancelModal.confirm': 'Confirm cancellation',
    'orders.modifyModal.title': 'Modify reservation',
    'orders.modifyModal.checkIn': 'Check-in date',
    'orders.modifyModal.checkOut': 'Check-out date',
    'orders.modifyModal.guests': 'Number of guests',
    'orders.modifyModal.save': 'Save changes',
    'orders.paymentModal.title': 'Complete payment',
    'orders.paymentModal.totalAmount': 'Total amount',
    'orders.paymentModal.cardNumber': 'Card number',
    'orders.paymentModal.cardNumberPlaceholder': '1234 5678 9012 3456',
    'orders.paymentModal.expiryDate': 'Expiry date',
    'orders.paymentModal.expiryPlaceholder': 'MM/YY',
    'orders.paymentModal.cvv': 'CVV',
    'orders.paymentModal.cvvPlaceholder': '123',
    'orders.paymentModal.pay': 'Pay {amount}$ CAD',
    'orders.needHelpTitle': 'Need help with your reservations?',
    'orders.needHelpSubtitle': 'Our team is here to help you with your questions and modifications',
    'orders.newReservation': 'New reservation',
    'orders.contactSupport': 'Contact support',
    'orders.contactToModify': 'To modify or cancel, please contact the campsite.',
    'orders.lodgeName': 'Pignon Rouge Lodge',
    'orders.completed': 'Completed',
    'orders.cancelModalTitle': 'Cancel Reservation',
    'orders.cancelModalSubtitle': 'Are you sure you want to cancel this reservation? This action is irreversible.',
    'orders.confirmCancellation': 'Confirm Cancellation',
    'orders.modifyModalTitle': 'Modify Reservation',
    'orders.saveModifications': 'Save Modifications',
    'orders.paymentModalTitle': 'Complete Payment',
    'orders.paymentModalSubtitle': 'Please enter your payment information to complete the reservation.',
    'orders.completePayment': 'Complete Payment',
    'orders.help.title': 'Need help with your reservations?',
    'orders.help.description': 'Our team is here to help you with your questions and modifications',
    'orders.help.newReservation': 'New reservation',
    'orders.help.contactSupport': 'Contact support',
    'orders.billings': 'Billings',
    'orders.billings.title': 'My Billings',
    'orders.billings.subtitle': 'View and download your invoices',
    'orders.billings.invoice': 'Invoice',
    'orders.billings.date': 'Date',
    'orders.billings.amount': 'Amount',
    'orders.billings.status': 'Status',
    'orders.billings.download': 'Download',
    'orders.billings.view': 'View',
    'orders.billings.paid': 'Paid',
    'orders.billings.pending': 'Pending',
    'orders.billings.overdue': 'Overdue',
    'orders.billings.noBillings': 'No billings available',
    'orders.billings.noBillingsDesc': 'Your invoices will appear here after your reservations',
    'orders.waitingToComplete': 'Waiting to complete',
    'orders.noPaid': 'No paid reservations',
    'orders.noPaidDesc': 'Your paid reservations will appear here',
    'orders.noWaiting': 'No waiting reservations',
    'orders.noWaitingDesc': 'Your reservations waiting for payment will appear here',
    'orders.reminder.title': 'Important reminders',
    'orders.reminder.cancellationDeadline': '⚠️ Cancellation deadline: Less than 5 days before arrival',
    'orders.reminder.modificationDeadline': '⚠️ Modification deadline: Less than 7 days before arrival',

    // Points Management
    'points.title': 'My Points',
    'points.navLabel': 'My Points',
    'points.subtitle': 'Manage your loyalty points and exchange them for rewards',
    'points.current': 'Current points',
    'points.lifetime': 'Lifetime points',
    'points.availableRewards': 'Available rewards',
    'points.pointValue': '1 point = $0.10 CAD',
    'points.reduction': 'reduction',
    'points.estimatedCreditLine': 'Estimated credit: {amount} $ CAD',
    'points.adjustment': 'Points adjustment',
    'points.adjustmentDesc': 'Administrators can adjust member loyalty points',
    'points.adjust': 'Adjust points',
    'points.rewards': 'Available rewards',
    'points.transactionHistory': 'Transaction history',
    'points.earned': 'Points earned for reservation',
    'points.redeemed': 'Exchange for {amount}$ discount',
    'points.adjusted': 'Administrative adjustment',
    'points.adjustModal.title': 'Adjust points',
    'points.adjustModal.amount': 'Amount (positive to add, negative to remove)',
    'points.adjustModal.amountPlaceholder': 'Ex: 100 or -50',
    'points.adjustModal.reason': 'Adjustment reason',
    'points.adjustModal.reasonPlaceholder': 'Explain the reason for this adjustment...',
    'points.adjustModal.confirm': 'Confirm adjustment',
    'points.reward.discount25': '$25 discount',
    'points.reward.discount25Desc': 'Save $25 on your next reservation',
    'points.reward.discount50': '$50 discount',
    'points.reward.discount50Desc': 'Save $50 on your next reservation',
    'points.reward.freeNight': 'Free night',
    'points.reward.freeNightDesc': 'Get a free night for your stay',
    'points.reward.vipPackage': 'VIP Package',
    'points.reward.vipPackageDesc': 'Access to VIP package with all benefits',
    'points.reward.exchange': 'Exchange',
    'points.reward.pointsRequired': '{points} points',
    'points.transaction.earnedReservation': 'Points earned for reservation',
    'points.transaction.redeemedDiscount': 'Exchange for {amount}$ discount',
    'points.transaction.adminAdjustment': 'Administrative adjustment',
    'points.points': 'points',
    'points.currentLabel': 'Current points',
    'points.lifetimeLabel': 'Lifetime points',
    'points.availableRewardsLabel': 'Available rewards',

    // Offers Management
    'offers.title': 'My Offers',
    'offers.navLabel': 'My Offers',
    'offers.subtitle': 'View and use special offers sent to you',
    'offers.active': 'Active offers',
    'offers.expired': 'Expired offers',
    'offers.used': 'Used offers',
    'offers.noActive': 'No active offers',
    'offers.noExpired': 'No expired offers',
    'offers.noUsed': 'No used offers',
    'offers.noActiveDesc': 'You currently have no active offers',
    'offers.noExpiredDesc': 'No expired offers in your history',
    'offers.noUsedDesc': 'No used offers in your history',
    'offers.activeStatus': 'Active',
    'offers.expiredStatus': 'Expired',
    'offers.usedStatus': 'Used',
    'offers.promotionalCode': 'Promotional code',
    'offers.validFrom': 'From {from} to {until}',
    'offers.terms': 'Terms',
    'offers.useOffer': 'Use offer',
    'offers.discount': 'discount',
    'offers.multiplier': 'multiplier',
    'offers.activeLabel': 'Active offers',
    'offers.expiredLabel': 'Expired offers',
    'offers.usedLabel': 'Used offers',
    'offers.tabActive': 'Active',
    'offers.tabExpired': 'Expired',
    'offers.tabUsed': 'Used',
    'offers.example1.title': '20% discount on your next reservation',
    'offers.example1.description': 'Enjoy a 20% discount on all available accommodations. Valid until the end of the month.',
    'offers.example1.terms': 'Minimum 2 nights. Not combinable with other offers.',
    'offers.example2.title': '$50 discount',
    'offers.example2.description': 'Save $50 on your 3-night or longer reservation.',
    'offers.example2.terms': 'Minimum 3-night reservation required.',
    'offers.example3.title': 'Double your loyalty points',
    'offers.example3.description': 'Earn double points on your next stay.',
    'offers.example3.terms': 'Offer valid in January 2024 only.',
    'offers.example4.title': 'Special weekend - 15% discount',
    'offers.example4.description': 'Special discount for weekend reservations.',
    'offers.example4.terms': 'Valid only for Friday to Sunday reservations.',
    'offers.validFromTo': 'From {from} to {until}',

    // Settings
    'settings.title': 'Account Settings',
    'settings.navLabel': 'Settings',
    'settings.subtitle': 'Manage your personal information and account preferences',
    'settings.personalInfo': 'Personal information',
    'settings.updateProfile': 'Update your profile information',
    'settings.edit': 'Edit',
    'settings.firstName': 'First name',
    'settings.lastName': 'Last name',
    'settings.email': 'Email address',
    'settings.phone': 'Phone',
    'settings.saveChanges': 'Save changes',
    'settings.preferences': 'Preferences',
    'settings.customizeExperience': 'Customize your experience',
    'settings.preferredLanguage': 'Preferred language',
    'settings.emailNotifications': 'Email notifications',
    'settings.emailNotificationsDesc': 'Receive notifications about your reservations and special offers',
    'settings.savePreferences': 'Save preferences',
    'settings.security': 'Security',
    'settings.managePassword': 'Manage your password and account security',
    'settings.changePassword': 'Change password',
    'settings.lastPasswordChange': 'Last password change: {months} months ago',

    // Shopcart
    'shopcart.title': 'My Cart',
    'shopcart.navLabel': 'My Cart',
    'shopcart.subtitle': 'Manage your favorites, likes, and share your discoveries',
    'shopcart.favorites': 'Favorites',
    'shopcart.liked': 'Liked',
    'shopcart.shared': 'Shared',
    'shopcart.addToFavorites': 'Add to favorites',
    'shopcart.removeFromFavorites': 'Remove from favorites',
    'shopcart.like': 'Like',
    'shopcart.unlike': 'Unlike',
    'shopcart.share': 'Share',
    'shopcart.noFavorites': 'No favorites',
    'shopcart.noFavoritesDesc': 'Add accommodations or activities to your favorites',
    'shopcart.noLiked': 'No liked items',
    'shopcart.noLikedDesc': 'Items you like will appear here',
    'shopcart.noShared': 'No shared items',
    'shopcart.noSharedDesc': 'Items you share will appear here',
    'shopcart.shareSuccess': 'Link copied to clipboard',
    'shopcart.remove': 'Remove',
    'shopcart.viewDetails': 'View details',

    // Shopping Cart Assistant
    'shoppingCart.title': 'Booking Assistant',
    'shoppingCart.subtitle': 'Plan your stay in a few steps',
    'shoppingCart.travelDuration': 'Travel Duration',
    'shoppingCart.selectDates': 'Select your start and end dates (2026-2027)',
    'shoppingCart.chooseFirstDay': 'First day',
    'shoppingCart.chooseLastDay': 'Last day',
    'shoppingCart.durationHint':
      'Adjust nights anytime — or tap two days on the calendar to set a period.',
    'shoppingCart.startDate': 'Start Date',
    'shoppingCart.endDate': 'End Date',
    'shoppingCart.notSelected': 'Not selected',
    'shoppingCart.applyingConditions': 'Applying cart conditions',
    'shoppingCart.duration': 'Duration',
    'shoppingCart.days': 'days',
    'shoppingCart.groupDetails': 'Group Details',
    'shoppingCart.numberOfGroups': 'Number of Groups',
    'shoppingCart.group': 'group',
    'shoppingCart.groups': 'groups',
    'shoppingCart.numberOfAdults': 'Number of Adults',
    'shoppingCart.adult': 'adult',
    'shoppingCart.adults': 'adults',
    'shoppingCart.numberOfKids': 'Number of Kids',
    'shoppingCart.kid': 'kid',
    'shoppingCart.kids': 'kids',
    'shoppingCart.totalGuests': 'Total Guests',
    'shoppingCart.guests': 'guests',
    'shoppingCart.totalGroups': 'Total Groups',
    'shoppingCart.continue': 'Continue',
    'shoppingCart.continueDescription': 'You will be able to add products to your cart',
    'shoppingCart.saveBookingConditions': 'Confirm',
    'shoppingCart.bookingConditionsUpdated': 'Your travel info has been updated.',
    'shoppingCart.bookingConditions': 'Travel info',
    'shoppingCart.updateTravelInfo': 'Update travel info',
    'shoppingCart.updateTravelInfoDesc':
      'Save your dates and group size so we can show the right availability.',
    'shoppingCart.updateTravelInfoConfirm': 'Confirm',
    'shoppingCart.discardTravelInfo': 'Discard changes',
    'shoppingCart.travelInfoRequired': 'Travel info required',
    'shoppingCart.travelInfoRequiredDesc':
      'Choose your dates and group in the calendar assistant so inventories display correctly.',
    'shoppingCart.openTravelAssistant': 'Open calendar assistant',
    'shoppingCart.startHereStep1': 'Start here · Step 1',
    'shoppingCart.startHereStep1Desc': 'Pick your dates, then set your groups.',
    'shoppingCart.milestoneDuration': 'Duration',
    'shoppingCart.milestoneGroups': 'Groups',
    'shoppingCart.calendarDockImHere': 'I am here',
    'shoppingCart.calendarDockImHereDesc': 'Re-open the calendar assistant from the dock.',
    'shoppingCart.myCart': 'My Cart',
    'shoppingCart.stepItems': 'Items',
    'shoppingCart.stepSummary': 'Summary',
    'shoppingCart.stepCheckout': 'Checkout',
    'shoppingCart.stepSummaryHint': 'Review taxes and totals for your selected items.',
    'shoppingCart.stepCheckoutHint': 'Choose how you want to complete your order.',
    'shoppingCart.capacityBlockedHint':
      'Group size exceeds VUM limits — adjust guests or contact us.',

    'shoppingCart.allItems': 'All Items',
    'shoppingCart.liked': 'Liked',
    'shoppingCart.favorites': 'Favorites',
    'shoppingCart.cartEmpty': 'Your cart is empty',
    'shoppingCart.cartEmptyDesc': 'Add stays, activities, or packages to your cart',
    'shoppingCart.noLikedItems': 'No liked items',
    'shoppingCart.noLikedItemsDesc': 'Items you like will appear here',
    'shoppingCart.noFavorites': 'No favorites',
    'shoppingCart.noFavoritesDesc': 'Your favorite items will appear here',
    'shoppingCart.open': 'Open Assistant',
    'shoppingCart.configureWithAssistant': 'Configure in booking assistant (dates & guests)',
    'shoppingCart.minimize': 'Minimize',
    'shoppingCart.expand': 'Expand',
    'shoppingCart.or': 'or',
    'shoppingCart.addGroup': 'Add Group',

    'checkout.staySummaryTitle': 'Stay summary',
    'checkout.staySummarySubtitle': 'Saved from booking assistant',
    'checkout.nightsCount': '{n} nights',
    'checkout.groupNumber': 'Group {n}',

    // Client-facing Accommodations
    'accommodations.subtitle': 'Discover our rustic cabins and yurts in the heart of Quebec nature',
    'accommodations.searchPlaceholder': 'Search accommodation...',
    'accommodations.typeFilter': 'Accommodation type',
    'accommodations.locationFilter': 'Location',
    'accommodations.capacityFilter': 'Capacity',
    'accommodations.viewCalendar': 'View calendar',
    'accommodations.hideCalendar': 'Hide calendar',
    'accommodations.typesCalendar': 'Accommodation types calendar',
    'stays.viewCalendar': 'View calendar',
    'stays.hideCalendar': 'Hide calendar',
    'stays.typesCalendar': 'Accommodation types calendar',
    'accommodations.typesDescription': 'Check availability by accommodation type',
    'accommodations.availability': 'Availability',
    'accommodations.close': 'Close',
    'accommodations.noResults': 'No accommodation found',
    'accommodations.tryOtherFilters': 'Try modifying your search criteria',
    'accommodations.resultsCount': 'accommodation found',
    'accommodations.resultsCountPlural': 'accommodations found',
    'accommodations.filtersApplied': 'Filters applied',
    'accommodations.allTypes': 'All types',
    'accommodations.allLocations': 'All locations',
    'accommodations.allCapacities': 'All capacities',
    'accommodations.chalets': 'Cabins',
    'accommodations.yourtes': 'Yurts',
    'accommodations.units': 'Row units',
    'accommodations.lake': 'Lakefront',
    'accommodations.forest': 'In forest',
    'accommodations.mixed': 'Mixed',
    'accommodations.capacity2': '2 persons',
    'accommodations.capacity4': '4 persons',
    'accommodations.capacity6': '5-6 persons',
    'accommodations.capacity7': '7+ persons',
    'accommodations.chalets.desc': 'Rustic cabins with full amenities',
    'accommodations.yourtes.desc': 'Comfortable yurts in nature',
    'accommodations.units.desc': 'Modern units with services',
    'accommodations.cabane': 'Cabin',
    'accommodations.cabane.desc': 'Traditional hunting/fishing cabins',
    'accommodations.tente': 'Tent',
    'accommodations.tente.desc': 'Luxury tents with amenities',

    // Client-facing Activities
    'activities.subtitle': 'Discover our fishing, hunting and nature activities, summer and winter',
    'activities.seasonFilter': 'Filter by season',
    'activities.viewCalendar': 'View calendar',
    'activities.hideCalendar': 'Hide calendar',
    'activities.typesCalendar': 'Activity types calendar',
    'activities.typesDescription': 'Check availability by activity type',
    'activities.availability': 'Availability',
    'activities.close': 'Close',
    'activities.noResults': 'No activity found',
    'activities.tryOtherSeason': 'Try selecting another season',
    'activities.fishing': 'Fishing',
    'activities.fishing.desc': 'Ice fishing, river fishing, lake fishing',
    'activities.hunting': 'Hunting',
    'activities.hunting.desc': 'Deer hunting, moose hunting, small game hunting',
    'activities.hiking': 'Hiking',
    'activities.hiking.desc': 'Snowshoe hiking, hiking, bike hiking',
    'activities.observation': 'Observation',
    'activities.observation.desc': 'Wildlife watching, bird watching',
    'activities.photography': 'Photography',
    'activities.photography.desc': 'Nature photography, wildlife photography',
    'activities.fishingWalleye': 'Walleye fishing',
    'activities.fishingWalleye.desc': 'Guided walleye fishing on our private lakes',
    'activities.kayak': 'Kayak',
    'activities.kayak.desc': 'Kayak rental to explore the lakes',
    'activities.guidedHiking': 'Guided hiking',
    'activities.guidedHiking.desc': 'Forest hiking with naturalist guide',
    'activities.deerHunting': 'Deer hunting',
    'activities.deerHunting.desc': 'Guided deer hunting in forest',
    'activities.crossCountrySkiing': 'Cross-country skiing',
    'activities.crossCountrySkiing.desc': 'Maintained cross-country ski trails',
    'activities.iceFishing': 'Ice fishing',
    'activities.iceFishing.desc': 'Ice fishing with experienced guide',

    // Packages
    'packages.familyFishing': 'Family Fishing Package',
    'packages.familyFishing.desc': '2 nights + guided fishing + kayak for the whole family',
    'packages.romanticWeekend': 'Romantic Weekend',
    'packages.romanticWeekend.desc': '2 nights in intimate cabin + hiking + candlelight dinner',
    'packages.winterAdventure': 'Winter Adventure',
    'packages.winterAdventure.desc': '3 nights + cross-country skiing + ice fishing + yurt',

    // Chalets
    'chalets.leRenard': 'Le Renard',
    'chalets.leRenard.desc': 'Rustic lakeside cabin with private dock and outdoor fireplace.',
    'chalets.leLynx': 'Le Lynx',
    'chalets.leLynx.desc': 'Spacious cabin perfect for families with panoramic lake view.',
    'chalets.laPerdrix': 'La Perdrix',
    'chalets.laPerdrix.desc': 'Intimate forest cabin, ideal for a romantic stay.',
    'chalets.leLoup': 'Le Loup',
    'chalets.leLoup.desc': 'Large luxury cabin with all amenities for large groups.',
    'chalets.leHuard': 'Le Huard',
    'chalets.leHuard.desc': 'Compact waterfront cabin with direct lake access.',
    'chalets.laBecasse': 'La Bécasse',
    'chalets.laBecasse.desc': 'Cabin between lake and forest, perfect for nature lovers.',
    'chalets.lOriginal': 'L\'Original',
    'chalets.lOriginal.desc': 'Premium cabin with exceptional view and all amenities.',

    // Guest
    'guest.accommodations.subtitle': 'Discover our rustic cabins and yurts in the heart of Quebec nature',
    'guest.activities.subtitle': 'Discover our fishing, hunting and nature activities, summer and winter',
    'guest.packages.subtitle': 'Discover our all-inclusive packages for a complete nature experience',
    'guest.dashboard.welcome': 'Welcome in guest mode',
    'guest.dashboard.explore': 'Explore our offers without creating an account',
    'guest.dashboard.createAccount': 'Create an account to book',
    'guest.dashboard.login': 'Login to existing account',

    // Home
    'home.featuredChalets': 'Featured cabins',
    'home.viewAll': 'View all',
    'home.popularActivities': 'Popular activities',
    'home.specialPackages': 'Special packages',
    'home.needHelp': 'Need help planning your activities?',
    'home.helpDescription': 'Our team of experts can help you create the perfect experience according to your preferences',
    'home.contactUs': 'Contact us',
    'home.discoverPackages': 'Discover our all-inclusive packages for a complete nature experience',
  },
  zh: {
    // Dashboard
    'dashboard.welcome': '欢迎，{name}！',
    'dashboard.subtitle': '在阿比蒂比-特米斯卡明格的中心发现我们质朴的小屋和自然活动',
    'dashboard.availableChalets': '可用小屋',
    'dashboard.activities': '活动',
    'dashboard.specialPackages': '特别套餐',
    'dashboard.pureNature': '纯自然',
    'dashboard.featuredChalets': '特色小屋',
    'dashboard.popularActivities': '热门活动',
    'dashboard.specialOffers': '特别优惠',
    'dashboard.viewAll': '查看全部',
    'dashboard.bookNow': '立即预订',
    'dashboard.lastVisit': '上次访问',
    'dashboard.recentActivity': '最近活动',
    'dashboard.satisfaction': '满意度',
    'dashboard.averageRating': '平均评分',
    'dashboard.basedOnRatings': '基于您的评分',
    'dashboard.yourComment': '您的评论',
    'dashboard.lastReview': '最后评论',
    'dashboard.viewAllComments': '查看所有评论',
    'dashboard.activeReservations': '活跃预订',
    'dashboard.pendingPayments': '待付款',
    'dashboard.completedStays': '已完成住宿',
    'dashboard.totalSpent': '总支出',
    'dashboard.upcomingReservations': '即将到来的预订',
    'dashboard.noUpcomingReservations': '没有即将到来的预订',
    'dashboard.noReservationsPlanned': '您目前没有计划的预订',
    'dashboard.newReservation': '新预订',
    'dashboard.orderManagement': '订单管理',
    'dashboard.manageReservations': '管理您的预订，修改日期，取消或完成付款',
    'dashboard.viewAllOrders': '查看我的所有订单',
    'dashboard.today': '今天',
    'dashboard.yesterday': '昨天',
    'dashboard.daysAgo': '{count}天前',
    'dashboard.weeksAgo': '{count}周前',
    'dashboard.monthsAgo': '{count}个月前',
    'dashboard.yearsAgo': '{count}年前',
    'dashboard.pointsMilestone': '我的积分里程碑和洞察',
    'dashboard.pointsInsight': '积分洞察',
    'dashboard.nextMilestone': '下一个里程碑',
    'dashboard.pointsUntilNext': '距离下一个里程碑还有 {points} 积分',
    'dashboard.reservationBoard': '预订看板',
    'dashboard.reservationDetails': '预订详情',
    'dashboard.satisfactionFeedback': '满意度和反馈',
    'dashboard.leaveFeedback': '留下反馈',
    'dashboard.feedbackTitle': '分享您的体验',
    'dashboard.feedbackDescription': '您的反馈帮助我们改进服务',
    'dashboard.rating': '评分',
    'dashboard.comment': '评论',
    'dashboard.submitFeedback': '提交反馈',
    'dashboard.yourRating': '您的评分',
    'dashboard.writeComment': '在此写下您的评论...',
    'dashboard.person': '人',
    'dashboard.persons': '人',
    'dashboard.loyaltyPointWorth': '1 积分 = {value} 加元可抵扣',
    'dashboard.loyaltyApproxCredit': '约 {amount} 加元可抵扣额度',
    'dashboard.loyaltyTotalSpentBeforeTax': '累计消费（税前）：{amount} 加元',
    'dashboard.vumNoPackages': '暂无可用的 VUM 套餐',
    'dashboard.vumPackagesReady': '有 {count} 个 VUM 套餐可预订',
    'dashboard.milestoneReachLevel': '晋级目标等级：{label}',

    // Questionnaire
    'questionnaire.title': '问卷',
    'questionnaire.start': '回答问题',
    'questionnaire.answerToAccumulate': '回答问题以累积积分',
    'questionnaire.question': '问题',
    'questionnaire.submit': '提交',
    'questionnaire.next': '下一个',
    'questionnaire.previous': '上一个',
    'questionnaire.progress': '第 {current} 题，共 {total} 题',
    'questionnaire.pointsReward': '+{points} 积分',
    'questionnaire.ratingSelected': '您选择了 {rating} 星',
    'questionnaire.textHint': '您的答案有助于我们改进服务',
    'questionnaire.completed': '问卷完成！您获得了 {points} 积分。',
    'questionnaire.textPlaceholder': '在此输入您的答案...',
    'questionnaire.q1.question': '您最喜欢的露营活动是什么？',
    'questionnaire.q1.option1': '徒步',
    'questionnaire.q1.option2': '钓鱼',
    'questionnaire.q1.option3': '观察野生动物',
    'questionnaire.q1.option4': '在小屋放松',
    'questionnaire.q2.question': '您如何评价整体体验？',
    'questionnaire.q3.question': '您有什么建议来改善我们的服务吗？',

    // Orders Management
    'orders.title': '我的订单',
    'orders.navLabel': '我的订单',
    'orders.subtitle': '管理您的预订并查看您的住宿历史',
    'orders.upcoming': '即将到来',
    'orders.past': '过去',
    'orders.cancelled': '已取消',
    'orders.noUpcoming': '没有即将到来的预订',
    'orders.noPast': '没有过去的预订',
    'orders.noCancelled': '没有已取消的预订',
    'orders.startBooking': '开始预订住宿',
    'orders.pastWillAppear': '您过去的预订将显示在这里',
    'orders.cancelledWillAppear': '您已取消的预订将显示在这里',
    'orders.confirmed': '已确认',
    'orders.pending': '待处理',
    'orders.cancelledStatus': '已取消',
    'orders.paid': '已支付',
    'orders.paymentPartial': '部分付款',
    'orders.paymentPending': '未付款',
    'orders.refunded': '已退款',
    'orders.modify': '修改',
    'orders.cancel': '取消',
    'orders.pay': '支付',
    'orders.payToComplete': '支付以完成',
    'orders.viewDetails': '查看详情',
    'orders.reservedOn': '预订于 {date}',
    'orders.paymentComplete': '付款完成',
    'orders.paymentPendingStatus': '付款待处理',
    'orders.balanceDueAtArrival': '到达时应付余额：{amount} CAD',
    'orders.amountDue': '应付金额：{amount} CAD',
    'orders.priceTotal': '总计',
    'orders.pricePaid': '已付',
    'orders.priceBalance': '到达时余额',
    'orders.cancelModal.title': '取消预订',
    'orders.cancelModal.message': '您确定要取消此预订吗？此操作不可逆。将根据我们的取消政策进行退款。',
    'orders.cancelModal.back': '返回',
    'orders.cancelModal.confirm': '确认取消',
    'orders.modifyModal.title': '修改预订',
    'orders.modifyModal.checkIn': '入住日期',
    'orders.modifyModal.checkOut': '退房日期',
    'orders.modifyModal.guests': '客人数量',
    'orders.modifyModal.save': '保存更改',
    'orders.paymentModal.title': '完成付款',
    'orders.paymentModal.totalAmount': '总金额',
    'orders.paymentModal.cardNumber': '卡号',
    'orders.paymentModal.cardNumberPlaceholder': '1234 5678 9012 3456',
    'orders.paymentModal.expiryDate': '有效期',
    'orders.paymentModal.expiryPlaceholder': 'MM/YY',
    'orders.paymentModal.cvv': 'CVV',
    'orders.paymentModal.cvvPlaceholder': '123',
    'orders.paymentModal.pay': '支付 {amount}$ 加元',
    'orders.help.title': '需要预订帮助？',
    'orders.help.description': '我们的团队随时为您提供帮助和修改',
    'orders.help.newReservation': '新预订',
    'orders.help.contactSupport': '联系支持',
    'orders.contactToModify': '如需修改或取消，请联系营地。',
    'orders.lodgeName': '红松小屋',
    'orders.completed': '已完成',
    'orders.cancelModalTitle': '取消预订',
    'orders.cancelModalSubtitle': '您确定要取消此预订吗？此操作不可逆。',
    'orders.confirmCancellation': '确认取消',
    'orders.modifyModalTitle': '修改预订',
    'orders.saveModifications': '保存更改',
    'orders.paymentModalTitle': '完成付款',
    'orders.paymentModalSubtitle': '请输入您的付款信息以完成预订。',
    'orders.completePayment': '完成付款',
    'orders.billings': '账单',
    'orders.billings.title': '我的账单',
    'orders.billings.subtitle': '查看和下载您的发票',
    'orders.billings.invoice': '发票',
    'orders.billings.date': '日期',
    'orders.billings.amount': '金额',
    'orders.billings.status': '状态',
    'orders.billings.download': '下载',
    'orders.billings.view': '查看',
    'orders.billings.paid': '已支付',
    'orders.billings.pending': '待处理',
    'orders.billings.overdue': '逾期',
    'orders.billings.noBillings': '没有可用账单',
    'orders.billings.noBillingsDesc': '您的发票将在预订后显示在这里',
    'orders.waitingToComplete': '等待完成',
    'orders.noPaid': '没有已支付的预订',
    'orders.noPaidDesc': '您已支付的预订将显示在这里',
    'orders.noWaiting': '没有等待的预订',
    'orders.noWaitingDesc': '您等待付款的预订将显示在这里',
    'orders.reminder.title': '重要提醒',
    'orders.reminder.cancellationDeadline': '⚠️ 取消截止日期：距离到达少于5天',
    'orders.reminder.modificationDeadline': '⚠️ 修改截止日期：距离到达少于7天',

    // Points Management
    'points.title': '我的积分',
    'points.navLabel': '我的积分',
    'points.subtitle': '管理您的忠诚度积分并兑换奖励',
    'points.current': '当前积分',
    'points.lifetime': '终身积分',
    'points.availableRewards': '可用奖励',
    'points.pointValue': '1 积分 = 0.10$ 加元',
    'points.reduction': '抵扣',
    'points.estimatedCreditLine': '约可抵扣：{amount} 加元',
    'points.adjustment': '积分调整',
    'points.adjustmentDesc': '管理员可以调整会员忠诚度积分',
    'points.adjust': '调整积分',
    'points.rewards': '可用奖励',
    'points.transactionHistory': '交易历史',
    'points.transaction.earnedReservation': '预订获得的积分',
    'points.transaction.redeemedDiscount': '兑换 {amount}$ 折扣',
    'points.transaction.adminAdjustment': '管理调整',
    'points.points': '积分',
    'points.currentLabel': '当前积分',
    'points.lifetimeLabel': '终身积分',
    'points.availableRewardsLabel': '可用奖励',
    'points.earned': '预订获得的积分',
    'points.redeemed': '兑换 {amount}$ 折扣',
    'points.adjusted': '管理调整',
    'points.adjustModal.title': '调整积分',
    'points.adjustModal.amount': '金额（正数添加，负数扣除）',
    'points.adjustModal.amountPlaceholder': '例如：100 或 -50',
    'points.adjustModal.reason': '调整原因',
    'points.adjustModal.reasonPlaceholder': '解释此调整的原因...',
    'points.adjustModal.confirm': '确认调整',
    'points.reward.discount25': '25$ 折扣',
    'points.reward.discount25Desc': '下次预订节省 25$',
    'points.reward.discount50': '50$ 折扣',
    'points.reward.discount50Desc': '下次预订节省 50$',
    'points.reward.freeNight': '免费住宿',
    'points.reward.freeNightDesc': '获得一晚免费住宿',
    'points.reward.vipPackage': 'VIP套餐',
    'points.reward.vipPackageDesc': '享受VIP套餐的所有福利',
    'points.reward.exchange': '兑换',
    'points.reward.pointsRequired': '{points} 积分',

    // Offers Management
    'offers.title': '我的优惠',
    'offers.navLabel': '我的优惠',
    'offers.subtitle': '查看和使用发送给您的特别优惠',
    'offers.active': '活跃优惠',
    'offers.expired': '已过期优惠',
    'offers.used': '已使用优惠',
    'offers.noActive': '没有活跃优惠',
    'offers.noExpired': '没有已过期优惠',
    'offers.noUsed': '没有已使用优惠',
    'offers.noActiveDesc': '您目前没有活跃优惠',
    'offers.noExpiredDesc': '您的历史记录中没有已过期优惠',
    'offers.noUsedDesc': '您的历史记录中没有已使用优惠',
    'offers.activeStatus': '活跃',
    'offers.expiredStatus': '已过期',
    'offers.usedStatus': '已使用',
    'offers.promotionalCode': '促销代码',
    'offers.validFrom': '从 {from} 到 {until}',
    'offers.terms': '条款',
    'offers.useOffer': '使用优惠',
    'offers.discount': '折扣',
    'offers.multiplier': '倍数',
    'offers.activeLabel': '活跃优惠',
    'offers.expiredLabel': '已过期优惠',
    'offers.usedLabel': '已使用优惠',
    'offers.tabActive': '活跃',
    'offers.tabExpired': '已过期',
    'offers.tabUsed': '已使用',
    'offers.example1.title': '下次预订享受 20% 折扣',
    'offers.example1.description': '享受所有可用住宿 20% 折扣。有效期至月底。',
    'offers.example1.terms': '最少 2 晚。不可与其他优惠叠加。',
    'offers.example2.title': '50$ 折扣',
    'offers.example2.description': '3 晚或更长时间的预订可节省 50$。',
    'offers.example2.terms': '需要最少 3 晚预订。',
    'offers.example3.title': '双倍忠诚度积分',
    'offers.example3.description': '下次住宿获得双倍积分。',
    'offers.example3.terms': '仅限 2024 年 1 月有效。',
    'offers.example4.title': '特别周末 - 15% 折扣',
    'offers.example4.description': '周末预订特别折扣。',
    'offers.example4.terms': '仅限周五至周日预订。',
    'offers.validFromTo': '从 {from} 到 {until}',

    // Settings
    'settings.title': '账户设置',
    'settings.navLabel': '设置',
    'settings.subtitle': '管理您的个人信息和账户偏好',
    'settings.personalInfo': '个人信息',
    'settings.updateProfile': '更新您的个人资料信息',
    'settings.edit': '编辑',
    'settings.firstName': '名字',
    'settings.lastName': '姓氏',
    'settings.email': '电子邮件地址',
    'settings.phone': '电话',
    'settings.saveChanges': '保存更改',
    'settings.preferences': '偏好设置',
    'settings.customizeExperience': '自定义您的体验',
    'settings.preferredLanguage': '首选语言',
    'settings.emailNotifications': '电子邮件通知',
    'settings.emailNotificationsDesc': '接收有关您的预订和特别优惠的通知',
    'settings.savePreferences': '保存偏好设置',
    'settings.security': '安全',
    'settings.managePassword': '管理您的密码和账户安全',
    'settings.changePassword': '更改密码',
    'settings.lastPasswordChange': '上次密码更改：{months} 个月前',

    // Shopcart
    'shopcart.title': '我的购物车',
    'shopcart.navLabel': '我的购物车',
    'shopcart.subtitle': '管理您的收藏、点赞和分享您的发现',
    'shopcart.favorites': '收藏',
    'shopcart.liked': '已点赞',
    'shopcart.shared': '已分享',
    'shopcart.addToFavorites': '添加到收藏',
    'shopcart.removeFromFavorites': '从收藏中移除',
    'shopcart.like': '点赞',
    'shopcart.unlike': '取消点赞',
    'shopcart.share': '分享',
    'shopcart.noFavorites': '没有收藏',
    'shopcart.noFavoritesDesc': '将住宿或活动添加到您的收藏',
    'shopcart.noLiked': '没有点赞的项目',
    'shopcart.noLikedDesc': '您点赞的项目将显示在这里',
    'shopcart.noShared': '没有分享的项目',
    'shopcart.noSharedDesc': '您分享的项目将显示在这里',
    'shopcart.shareSuccess': '链接已复制到剪贴板',
    'shopcart.remove': '移除',
    'shopcart.viewDetails': '查看详情',

    // Shopping Cart Assistant
    'shoppingCart.title': '预订助手',
    'shoppingCart.subtitle': '分几步规划您的住宿',
    'shoppingCart.travelDuration': '旅行时长',
    'shoppingCart.selectDates': '选择您的开始和结束日期（2026-2027）',
    'shoppingCart.chooseFirstDay': '第一天',
    'shoppingCart.chooseLastDay': '最后一天',
    'shoppingCart.durationHint': '可随时调整晚数，或在日历上点选两天来设定时段。',
    'shoppingCart.startDate': '开始日期',
    'shoppingCart.endDate': '结束日期',
    'shoppingCart.notSelected': '未选择',
    'shoppingCart.applyingConditions': '应用购物车条件',
    'shoppingCart.duration': '时长',
    'shoppingCart.days': '天',
    'shoppingCart.groupDetails': '团队详情',
    'shoppingCart.numberOfGroups': '团队数量',
    'shoppingCart.group': '团队',
    'shoppingCart.groups': '团队',
    'shoppingCart.numberOfAdults': '成人数量',
    'shoppingCart.adult': '成人',
    'shoppingCart.adults': '成人',
    'shoppingCart.numberOfKids': '儿童数量',
    'shoppingCart.kid': '儿童',
    'shoppingCart.kids': '儿童',
    'shoppingCart.totalGuests': '总客人',
    'shoppingCart.guests': '客人',
    'shoppingCart.totalGroups': '总团队',
    'shoppingCart.continue': '继续',
    'shoppingCart.continueDescription': '您将能够将产品添加到购物车',
    'shoppingCart.saveBookingConditions': '确认',
    'shoppingCart.bookingConditionsUpdated': '行程信息已更新。',
    'shoppingCart.bookingConditions': '行程信息',
    'shoppingCart.updateTravelInfo': '更新行程信息',
    'shoppingCart.updateTravelInfoDesc': '请保存日期与出行人数，以便显示正确的可订库存。',
    'shoppingCart.updateTravelInfoConfirm': '确认',
    'shoppingCart.discardTravelInfo': '放弃更改',
    'shoppingCart.travelInfoRequired': '需要行程信息',
    'shoppingCart.travelInfoRequiredDesc': '请先在日历助手中选择日期与出行人数，以便正确显示库存。',
    'shoppingCart.openTravelAssistant': '打开日历助手',
    'shoppingCart.startHereStep1': '从这里开始 · 第 1 步',
    'shoppingCart.startHereStep1Desc': '先选日期，再设置出行人数。',
    'shoppingCart.milestoneDuration': '行程时长',
    'shoppingCart.milestoneGroups': '出行人数',
    'shoppingCart.calendarDockImHere': '我在这里',
    'shoppingCart.calendarDockImHereDesc': '可从底部程序坞重新打开日历助手。',
    'shoppingCart.myCart': '我的购物车',
    'shoppingCart.stepItems': '商品',
    'shoppingCart.stepSummary': '合计',
    'shoppingCart.stepCheckout': '结算',
    'shoppingCart.stepSummaryHint': '请核对所选商品的税费与合计金额。',
    'shoppingCart.stepCheckoutHint': '请选择如何完成订单。',
    'shoppingCart.capacityBlockedHint': '出行人数超出 VUM 限额 — 请调整人数或联系我们。',

    'shoppingCart.allItems': '所有项目',
    'shoppingCart.liked': '喜欢',
    'shoppingCart.favorites': '收藏',
    'shoppingCart.cartEmpty': '您的购物车是空的',
    'shoppingCart.cartEmptyDesc': '将住宿、活动或套餐添加到购物车',
    'shoppingCart.noLikedItems': '没有喜欢的项目',
    'shoppingCart.noLikedItemsDesc': '您喜欢的项目将显示在这里',
    'shoppingCart.noFavorites': '没有收藏',
    'shoppingCart.noFavoritesDesc': '您的收藏项目将显示在这里',
    'shoppingCart.open': '打开助手',
    'shoppingCart.configureWithAssistant': '在预订助手中配置（日期与人数）',
    'shoppingCart.minimize': '最小化',
    'shoppingCart.expand': '展开',
    'shoppingCart.or': '或',
    'shoppingCart.addGroup': '添加团队',

    'checkout.staySummaryTitle': '住宿摘要',
    'checkout.staySummarySubtitle': '来自预订助手',
    'checkout.nightsCount': '{n} 晚',
    'checkout.groupNumber': '第 {n} 组',

    // Client-facing Accommodations
    'accommodations.subtitle': '在魁北克自然中心发现我们质朴的小屋和蒙古包',
    'accommodations.searchPlaceholder': '搜索住宿...',
    'accommodations.typeFilter': '住宿类型',
    'accommodations.locationFilter': '位置',
    'accommodations.capacityFilter': '容量',
    'accommodations.viewCalendar': '查看日历',
    'accommodations.hideCalendar': '隐藏日历',
    'accommodations.typesCalendar': '住宿类型日历',
    'stays.viewCalendar': '查看日历',
    'stays.hideCalendar': '隐藏日历',
    'stays.typesCalendar': '住宿类型日历',
    'accommodations.typesDescription': '按住宿类型查看可用性',
    'accommodations.availability': '可用性',
    'accommodations.close': '关闭',
    'accommodations.noResults': '未找到住宿',
    'accommodations.tryOtherFilters': '尝试修改您的搜索条件',
    'accommodations.resultsCount': '找到住宿',
    'accommodations.resultsCountPlural': '找到住宿',
    'accommodations.filtersApplied': '已应用筛选',
    'accommodations.allTypes': '所有类型',
    'accommodations.allLocations': '所有位置',
    'accommodations.allCapacities': '所有容量',
    'accommodations.chalets': '小屋',
    'accommodations.yourtes': '蒙古包',
    'accommodations.units': '排屋单位',
    'accommodations.lake': '湖畔',
    'accommodations.forest': '在森林中',
    'accommodations.mixed': '混合',
    'accommodations.capacity2': '2人',
    'accommodations.capacity4': '4人',
    'accommodations.capacity6': '5-6人',
    'accommodations.capacity7': '7+人',
    'accommodations.chalets.desc': '带完整设施质朴小屋',
    'accommodations.yourtes.desc': '自然中舒适的蒙古包',
    'accommodations.units.desc': '带服务的现代单位',
    'accommodations.cabane': '小屋',
    'accommodations.cabane.desc': '传统狩猎/钓鱼小屋',
    'accommodations.tente': '帐篷',
    'accommodations.tente.desc': '带设施的豪华帐篷',

    // Client-facing Activities
    'activities.subtitle': '发现我们的钓鱼、狩猎和自然活动，夏季和冬季',
    'activities.seasonFilter': '按季节筛选',
    'activities.viewCalendar': '查看日历',
    'activities.hideCalendar': '隐藏日历',
    'activities.typesCalendar': '活动类型日历',
    'activities.typesDescription': '按活动类型查看可用性',
    'activities.availability': '可用性',
    'activities.close': '关闭',
    'activities.noResults': '未找到活动',
    'activities.tryOtherSeason': '尝试选择另一个季节',
    'activities.fishing': '钓鱼',
    'activities.fishing.desc': '冰钓、河钓、湖钓',
    'activities.hunting': '狩猎',
    'activities.hunting.desc': '鹿狩猎、驼鹿狩猎、小猎物狩猎',
    'activities.hiking': '徒步',
    'activities.hiking.desc': '雪鞋徒步、徒步、自行车徒步',
    'activities.observation': '观察',
    'activities.observation.desc': '野生动物观察、鸟类观察',
    'activities.photography': '摄影',
    'activities.photography.desc': '自然摄影、野生动物摄影',
    'activities.fishingWalleye': '鲈鱼钓鱼',
    'activities.fishingWalleye.desc': '在我们私人湖泊上进行的鲈鱼钓鱼',
    'activities.kayak': '皮划艇',
    'activities.kayak.desc': '皮划艇租赁探索湖泊',
    'activities.guidedHiking': '导游徒步',
    'activities.guidedHiking.desc': '与自然主义导游一起在森林中徒步',
    'activities.deerHunting': '鹿狩猎',
    'activities.deerHunting.desc': '在森林中进行的导游鹿狩猎',
    'activities.crossCountrySkiing': '越野滑雪',
    'activities.crossCountrySkiing.desc': '维护良好的越野滑雪道',
    'activities.iceFishing': '冰钓',
    'activities.iceFishing.desc': '与经验丰富的导游一起冰钓',

    // Packages
    'packages.familyFishing': '家庭钓鱼套餐',
    'packages.familyFishing.desc': '2晚 + 导游钓鱼 + 全家皮划艇',
    'packages.romanticWeekend': '浪漫周末',
    'packages.romanticWeekend.desc': '2晚私密小屋 + 徒步 + 烛光晚餐',
    'packages.winterAdventure': '冬季冒险',
    'packages.winterAdventure.desc': '3晚 + 越野滑雪 + 冰钓 + 蒙古包',

    // Chalets
    'chalets.leRenard': 'Le Renard',
    'chalets.leRenard.desc': '湖畔质朴小屋，带私人码头和室外壁炉。',
    'chalets.leLynx': 'Le Lynx',
    'chalets.leLynx.desc': '宽敞小屋，适合家庭，可欣赏湖泊全景。',
    'chalets.laPerdrix': 'La Perdrix',
    'chalets.laPerdrix.desc': '森林中的私密小屋，适合浪漫住宿。',
    'chalets.leLoup': 'Le Loup',
    'chalets.leLoup.desc': '大型豪华小屋，适合大型团体，设施齐全。',
    'chalets.leHuard': 'Le Huard',
    'chalets.leHuard.desc': '紧凑的滨水小屋，可直接进入湖泊。',
    'chalets.laBecasse': 'La Bécasse',
    'chalets.laBecasse.desc': '位于湖泊和森林之间的小屋，适合自然爱好者。',
    'chalets.lOriginal': 'L\'Original',
    'chalets.lOriginal.desc': '高级小屋，视野极佳，设施齐全。',

    // Guest
    'guest.accommodations.subtitle': '在魁北克自然中心发现我们质朴的小屋和蒙古包',
    'guest.activities.subtitle': '发现我们的钓鱼、狩猎和自然活动，夏季和冬季',
    'guest.packages.subtitle': '发现我们的全包套餐，提供完整体验',
    'guest.dashboard.welcome': '欢迎访客模式',
    'guest.dashboard.explore': '无需创建账户即可探索我们的优惠',
    'guest.dashboard.createAccount': '创建账户以预订',
    'guest.dashboard.login': '登录现有账户',

    // Home
    'home.featuredChalets': '特色小屋',
    'home.viewAll': '查看全部',
    'home.popularActivities': '热门活动',
    'home.specialPackages': '特别套餐',
    'home.needHelp': '需要帮助规划您的活动吗？',
    'home.helpDescription': '我们的专家团队可以根据您的偏好帮助您创建完美的体验',
    'home.contactUs': '联系我们',
    'home.discoverPackages': '发现我们的全包套餐，提供完整体验',
  },
};

